<!-- eslint-disable vue/require-toggle-inside-transition -->
<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition duration-100 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div class="w-full max-w-sm bg-white rounded-lg shadow-lg pointer-events-auto">
      <div class="overflow-hidden rounded-lg shadow-xs">
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <!--Success-->
              <svg
                v-if="type==='success'"
                class="w-6 h-6 text-success"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>

              <!--Error-->
              <svg
                v-if="type==='error'"
                class="w-5 h-5 text-error"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <!--Content-->
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-bold leading-5 text-dark-900">
                {{ title }}
              </p>
              <div
                class="mt-1 text-sm leading-5 text-dark-500"
                v-html="description"
              />
            </div>
            <div
              class="flex flex-shrink-0 ml-4"
              @click="close"
            >
              <button class="inline-flex transition duration-150 ease-in-out rounded-md focus:outline-none focus:ring-2 focus:text-dark-500 text-dark-400">
                <svg
                  class="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const { title, description, type } = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'success'
  }
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};

</script>
